import type { FormControl } from '@angular/forms';

export enum InterviewKind {
  QUICK = 'rating',
  TEMPLATE = 'template_form',
}

export interface QuestionBase {
  questionTitle: FormControl<string>;
  questionHint?: FormControl<string>;
  questionRequired: FormControl<boolean>;
  time?: FormControl<number | string>;
  summary?: FormControl<boolean>;
}
